import * as common from "@/common.js"
import axios from 'axios'

export default {

    getUserEpicInstances() {
        let global = common.Singleton.getInstance(); //data cache on SPA side
        if (global.epicDestinations)
            return Promise.resolve(global.epicDestinations); //return promise with ready cached data without making additional HTTP calls

        if (!global.getUserEpicInstancesPromise) {
            //create a promise with own hooks 
            global.getUserEpicInstancesPromise = axios.get(`echos/user-of`).then((response) => {
                global.epicDestinations = response.data; //set obtained data to cache it
                return global.epicDestinations; //must return a result data to keep processing .then hook by invoking caller
            }).catch(error => {
                console.log('Error occured:' + error)
                return Promise.reject(error); //must return error promise in case other callers want to react to it as well
            });

            return global.getUserEpicInstancesPromise; //return axios created promise to first caller
        }
        else {
            return global.getUserEpicInstancesPromise; //return pending pomise to subsequent callers so they would attach to it without invoking an new HTTP call avoiding race condition (2+ components called getUserEpicInstances) 
        }
    },

    getUserStructure(epicDestination) {
        ///region Delete to disable SPA side cache
        let global = common.Singleton.getInstance(); //data cache on SPA side 
        if (!global.userStructure)
            global.userStructure = [];

        if (global.userStructure[epicDestination])
            return Promise.resolve(global.userStructure[epicDestination]); //return promise with ready data without making additional HTTP calls
        else
            global.userStructure[epicDestination] = null; //prepare array property
        ///end region 

        return axios.get(`echos/user-valid-values/${epicDestination}`).then((response) => {
            global.userStructure[epicDestination] = response.data ////Delete this line and region above to disable SPA side cache
            return response.data;
        }).catch(error => {
            console.log('Error occured:' + error)
            return Promise.reject(error);
        });
    }
}